import { fetchApiGetV2 } from '../../../../api/api'
import {
    setFontUrl,
} from './font_urlActions'

export interface FontUrl {
  url: string
}

const FontUrlAPI = {
    getFontUrl,
}
export default FontUrlAPI

export function getFontUrl() {
  return fetchApiGetV2<FontUrl>(`/fontUrl`, {}).then((res) =>
    setFontUrl(res.url)
  )
}